import { c as _c } from "react/compiler-runtime";
import { IconType } from "react-icons";
import { LuBadgeCheck, LuBookmark, LuCoins, LuPackage, LuPencil, LuTag } from "react-icons/lu";
import Badge, { type BadgeProps } from "@/components/ui/badge";
import { DiscountType } from "@/types/enums/discount";
interface DiscountTypeDescriptor {
  label: string;
  icon?: IconType;
  variant: BadgeProps["variant"];
}

/**
 * Visual descriptor per discount type. Manual discounts (CUSTOM, GLOBAL) share a
 * single attention-drawing treatment so a hand-applied discount stands out at a
 * glance; automatic discounts are calmer and distinguished by icon + label.
 */
const DESCRIPTORS: Record<DiscountType, DiscountTypeDescriptor> = {
  [DiscountType.PACKAGE]: {
    label: "Package",
    icon: LuPackage,
    variant: "neutral"
  },
  [DiscountType.MEMBERSHIP]: {
    label: "Membership",
    icon: LuBadgeCheck,
    variant: "neutral"
  },
  [DiscountType.PROMOTION]: {
    label: "Promo",
    icon: LuTag,
    variant: "neutral"
  },
  [DiscountType.SAVED_ITEM]: {
    label: "Banked",
    icon: LuBookmark,
    variant: "neutral"
  },
  [DiscountType.CUSTOM]: {
    label: "Manual",
    icon: LuPencil,
    variant: "warning"
  },
  [DiscountType.GLOBAL]: {
    label: "Manual",
    icon: LuPencil,
    variant: "warning"
  },
  [DiscountType.CASH_ROUNDING]: {
    label: "Cash rounding",
    icon: LuCoins,
    variant: "neutral"
  }
};
const FALLBACK: DiscountTypeDescriptor = {
  label: "Discount",
  variant: "neutral"
};
interface DiscountSourceBadgeProps {
  type: DiscountType | undefined;
  className?: string;
}

/**
 * Small badge that labels where a discount came from (package, membership,
 * promotion, banked, or a manual/staff-applied discount). Used on the checkout
 * charge page and the charge timeline so both surfaces label discounts the same
 * way. Carries text + icon (not color alone) so the source is legible for
 * color-blind users.
 */
export function DiscountSourceBadge(t0) {
  const $ = _c(5);
  const {
    type,
    className
  } = t0;
  const descriptor = type && DESCRIPTORS[type] || FALLBACK;
  let t1;
  if ($[0] !== className || $[1] !== descriptor.icon || $[2] !== descriptor.label || $[3] !== descriptor.variant) {
    t1 = <Badge size="xs" variant={descriptor.variant} icon={descriptor.icon} className={className}>{descriptor.label}</Badge>;
    $[0] = className;
    $[1] = descriptor.icon;
    $[2] = descriptor.label;
    $[3] = descriptor.variant;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}